module.exports = __webpack_public_path__ + "static/img/blue_staking_discount_coupon.c1a1fe94.png";